module.exports = __webpack_public_path__ + "img/img_qrCode_weChat.632652f1.jpg";